import { boolean, schema } from "@anna-money/anna-web-lib/serializer";

export class ComplianceData extends schema(
  {
    isFinished: boolean(),
    isSuccessful: boolean(),
  },
  "ComplianceData",
) {}
